// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"FQ-z","inlineTitle":"GQ-z","sponsoredAdsWrapper":"HQ-z","marketplaceRecosWrapper":"IQ-z"};